/** The view on screen, so a refresh or a shared link comes back on the same form. */
export const ViewParam = "view";

/** One param changed and the rest kept - `id` and `view` have to survive each other. */
export function withParam(
  current: URLSearchParams,
  key: string,
  value: string
) {
  const next = new URLSearchParams(current);
  next.set(key, value);

  return next;
}
